import "./WordsList.css";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import {
  FaArrowLeftLong,
  FaArrowRightLong,
  FaEllipsisVertical,
  FaRegPenToSquare,
  FaRegTrashCan,
} from "react-icons/fa6";
import axiosInstance from "../../api/axiosInstance";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

const WordsList = ({ isAddWord, setIsAddWord }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [word, setWord] = useState("");
  const [loading, setLoading] = useState(false);
  const [words, setWords] = useState([]);

  const { token } = JSON.parse(localStorage.getItem("auth"));

  const recordsPerPage = 25;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axiosInstance.post("/spam/add", { word });

      const { data } = response;

      if (data) toast.success(data.message);
    } catch (error) {
      toast.error("Error adding spam word");
      console.error("🚀 -> handleSubmit -> error:", error);
    } finally {
      setIsAddWord(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAllSpamWords = async () => {
      try {
        const response = await axiosInstance.get("/spam/all", {
          headers: { authorization: token },
        });

        if (response?.data?.data) {
          setWords(response.data.data);
        }
      } catch (error) {
        console.error("🚀 -> fetchAllSpamWords -> error:", error);
      }
    };

    if (!isAddWord) fetchAllSpamWords();
  }, [isAddWord, token]);

  const totalWordCount = words.length;
  const totalPages = Math.ceil(totalWordCount / recordsPerPage);

  const startIndex = (currentPage - 1) * recordsPerPage;
  const endIndex = startIndex + recordsPerPage;

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <>
      {isAddWord ? (
        <Container>
          <Row className="justify-content-md-center">
            <Col md={6}>
              <h2 className="text-center mb-4">Add New Word</h2>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="word">
                  <Form.Label>Spam Word</Form.Label>
                  <Form.Control
                    name="word"
                    onChange={(e) => {
                      setWord(e.target.value);
                    }}
                    placeholder="Enter word to block"
                    required
                    type="text"
                    value={word}
                  />
                </Form.Group>
                <Row className="mt-3">
                  <Col>
                    <Button
                      className="w-100"
                      disabled={loading}
                      onClick={() => {
                        setIsAddWord(false);
                      }}
                      type="button"
                      variant="danger"
                    >
                      Cancel
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      className="w-100"
                      disabled={loading}
                      type="submit"
                      variant="success"
                    >
                      {loading ? "Adding..." : "Add"}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      ) : (
        <div className="wordsListBox">
          <div className="wordsListHeader">
            <div className="wordListItem">
              <div className="wordBox">
                <p>Word</p>
              </div>
              <div className="actionBox"></div>
            </div>
          </div>
          <div className="wordsListBody">
            {words.slice(startIndex, endIndex).map((word, index) => (
              <div className="wordListItem" key={index}>
                <div className="wordBox">
                  <p>{word.word}</p>
                </div>
                <div className="actionBox">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <FaEllipsisVertical />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => {}}>
                        <FaRegPenToSquare className="me-2 text-success" />
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <FaRegTrashCan className="me-2 text-danger" />
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            ))}
          </div>
          <div className="paginationControls">
            <button
              disabled={currentPage === 1}
              onClick={handlePreviousPage}
              type="button"
            >
              <FaArrowLeftLong size={24} />
            </button>
            <span className="pageIndicator">
              Page {currentPage} of {totalPages}
            </span>
            <button
              disabled={currentPage === totalPages}
              onClick={handleNextPage}
              type="button"
            >
              <FaArrowRightLong size={24} />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default WordsList;
